import React, { useEffect } from 'react'
import HeroSection from './Hero/HeroSection'
import Navbar from './Navbar/Navbar'
import TractorSection from './Tractor/TractorSection'
import TractorByBudget from './Tractor/TractorByBudget'
import OtherTractorSection from './Tractor/OtherTractorSection'
import BrandSection from './Brand/BrandSection'
import StaticCompareTractors from './Compare/StaticCompareTractors'
import BlogSection from './Blog/BlogSection'
import Footer from './Footer'
import ToolSection from './Tool/ToolSection'
import ImplementSection from './Implement/ImplementSection'


function Home() {
  return (
    <div>
        <Navbar />
        <HeroSection />
        <TractorSection />
        <BrandSection />
        <StaticCompareTractors />
        <TractorByBudget />
        <OtherTractorSection type="Mini" />
        <OtherTractorSection type="Electric" />
        <ToolSection />
        <ImplementSection />
        <BlogSection />
        <Footer />

    </div>
  );
}

export default Home;
